<template>
  <el-button
    class="base-button"
    :class="[`base-button-${color}`,
             bgColor ? 'base-button-BG' : '']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    // 决定于边框的颜色
    color: {
      type: String,
      default: 'blue',
    },
    // 是否带背景色(默认为false)
    bgColor: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="less">
.base-button.el-button {
  > span {
    position: relative;
    z-index: 2;
  }
}
</style>

<style lang="less" scoped>
.base-button {
  height: 36px;
  border-radius: 10px;
  line-height: 0px;
  position: relative;
  overflow: hidden;
  &:focus {
    background: inherit;
  }
}
.base-button-blue {
  border-color: #3a6bd5;
  color: #3a6bd5;
  &:hover {
    background: #3a6bd5;
    color: #fff;
  }
  &.base-button-BG {
    background: #3a6bd5;
    color: #fff;
  }
}
.base-button-red {
  border-color: #e6795d;
  color: #e6795d;
  &:hover {
    background: #e6795d;
    color: #fff;
  }
  &.base-button-BG {
    background: #e6795d;
    color: #fff;
  }
}

.el-button--text {
  border: none;
  &:hover::after {
    background: none;
  }
  &.base-button-red:hover {
    color: #e6795d;
    opacity: 0.6;
    background: transparent;
    &:active {
      opacity: 1;
    }
  }
  &.base-button-blue:hover {
    opacity: 0.6;
    background: transparent;
    color: #3a6bd5;
    &:active {
      opacity: 1;
    }
  }
}

.el-button--mini {
  height: 26px;
  padding: 0 10px;
}
</style>
